import { format } from 'date-fns';

import { GridPaginationModel } from '@mui/x-data-grid';
import { Box, Card, Stack, Button, Divider, Typography, Pagination, Avatar } from '@mui/material';

import { GenerationHistoryItem } from 'src/api/models/generation-history';

import { LoadingBarHorizontal } from 'src/components/loading';

interface Props {
  generationHistory?: GenerationHistoryItem[];
  generationHistoryTotalCount?: number;
  isLoading?: boolean;
  paginationModel: GridPaginationModel;
  onPaginationModelChanged: (model: GridPaginationModel) => void;
  onPreviewStory: (story: GenerationHistoryItem) => void;
}

export default function GenerationHistoryMobile({
  generationHistory = [],
  generationHistoryTotalCount = 0,
  isLoading = false,
  paginationModel,
  onPaginationModelChanged,
  onPreviewStory,
}: Props) {
  const totalPages = Math.ceil(generationHistoryTotalCount / paginationModel.pageSize);

  if (isLoading) {
    return <LoadingBarHorizontal showLoading />;
  }

  if (!generationHistory?.length) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Typography>No generation history found</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
          },
          mb: 3,
        }}
      >
        {generationHistory.map((item) => (
          <Card key={item.id} sx={{ p: 3 }}>
            <Stack spacing={2}>
              <Stack spacing={1}>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2" color="text.secondary">
                    Created Date:
                  </Typography>
                  <Typography variant="body2">
                    {format(new Date(item.createdAt), 'MMM dd, yyyy HH:mm')}
                  </Typography>
                </Stack>

                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2" color="text.secondary">
                    User:
                  </Typography>
                  <Typography variant="body2" noWrap sx={{ maxWidth: '180px' }}>
                    {`${item.user?.firstName} ${item.user?.lastName}`}
                  </Typography>
                </Stack>

                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2" color="text.secondary">
                    Product:
                  </Typography>
                  <Typography variant="body2" noWrap sx={{ maxWidth: '180px' }}>
                    {item.product?.name || ''}
                  </Typography>
                </Stack>
              </Stack>

              <Divider />

              <Button
                variant="outlined"
                onClick={() => onPreviewStory(item)}
                sx={{ mt: 'auto', minHeight: 45 }}
              >
                Preview
              </Button>
            </Stack>
          </Card>
        ))}
      </Box>

      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Pagination
            count={totalPages}
            page={paginationModel.page + 1}
            onChange={(_event, page) => {
              onPaginationModelChanged({ ...paginationModel, page: page - 1 });
            }}
          />
        </Box>
      )}
    </Box>
  );
}
